import { makeAutoObservable } from 'mobx';
import { Map, Overlay } from 'ol';
import BaseLayer from 'ol/layer/Base';

export class SearchResultTooltips {
  searchResultTooltip: [BaseLayer, Overlay] | null = null;

  constructor() {
    makeAutoObservable(this);
  }

  setSearchTooltip(map: Map, markerLayer: BaseLayer, popupOverlay: Overlay) {
    this.searchResultTooltip = [markerLayer, popupOverlay];

    map.addOverlay(popupOverlay!);
    map.addLayer(markerLayer!);
  }

  removeSearchTooltip(map: Map) {
    map.removeOverlay(this.popupOverlay!);
    map.removeLayer(this.markerLayer!);

    this.searchResultTooltip = null;
  }

  get markerLayer() {
    if (this.searchResultTooltip === null) {
      return;
    }
    const [markerLayer] = this.searchResultTooltip!;

    return markerLayer;
  }

  get popupOverlay() {
    if (this.searchResultTooltip === null) {
      return;
    }
    const [, popupOverlay] = this.searchResultTooltip;

    return popupOverlay;
  }
}
